module.exports = __webpack_public_path__ + "img/area-4-1.a84207d.jpg";